<template>
	<fieldset id="billing-payment-method">
		<div class="flex items-center justify-between">
			<legend v-if="showHeaderAndInvoiceOption" class="heavy sz-2 mt-3" :class="{'mb-3':!showPrepaymentPaymentMethods}">Payment Method</legend>
			<button v-if="!showPrepaymentPaymentMethods && showHeaderAndInvoiceOption" type="button" class="button--no-style text-link underline text-1" @click="showInvoiceModal = true">
				Need an invoice?
			</button>
		</div>
		<ElRadioGroup
			v-if="showPrepaymentPaymentMethods"
			v-model="internalPaymentMethod"
			class="c-radio-fancy flex flex-wrap gap-x-3 mb-2"
			@change="emit('update:payment-method', $event)"
		>
			<ElRadioButton label="creditcard">Credit Card</ElRadioButton>
			<ElRadioButton label="invoice">Invoice</ElRadioButton>
		</ElRadioGroup>
		<CDialog
			:visible="showInvoiceModal"
			custom-class="dialog--tiny"
			@close="showInvoiceModal = false"
		>
			<div id="c-payment-invoice-popup">
				<p>Prepay for at least 3 months of the {{ newPlan.DisplayName }} plan and pay by check.</p>
			</div>
			<template #footer>
				<button class="button--secondary" @click="showInvoiceModal = false">No thanks</button>
				<button class="button--primary" @click="$router.replace(selectPlanUrl)">Get started!</button>
			</template>
		</CDialog>
		<CInput
			v-if="internalPaymentMethod === 'invoice' && !collectTaxId"
			id="invoice-number"
			:value="poNumber"
			type="text"
			data-testid="po-number"
			placeholder="PO Number"
			@change="emit('update:po-number', $event)"
		/>
		<BillingCardElement
			v-show="internalPaymentMethod !== 'invoice'"
			ref="stripeCard"
			:publishable-key="stripeKey"
			:card-on-file="cardOnFile"
			:existing-card-info="existingCardInfo"
			@change="emit('card-changed', $event)"
		>
		</BillingCardElement>
		<CCallout v-if="cardErrorMessage" type="error" size="s" class="mb-3">
			{{ cardErrorMessage }}
		</CCallout>
	</fieldset>
</template>
<script lang="ts">
	import CCallout from 'src/components/content/Callout.vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import BillingCardElement from 'src/components/app/BillingCardElement';
	import CInput from 'src/components/form-controls/Input.vue';
	import { RadioGroup, RadioButton } from '@cognitoforms/element-ui';

	import type { PropType } from 'vue';
	import { defineComponent, ref, watch } from 'vue';
	import type { Plan } from '@cognitoforms/types/server-types/plans/model/plan';

	export default defineComponent({
		name: 'CPaymentInformation',
		components: {
			CDialog,
			CCallout,
			BillingCardElement,
			CInput,
			ElRadioGroup: RadioGroup,
			ElRadioButton: RadioButton
		},
		props: {
			cardErrorMessage: {
				type: String,
				required: true
			},
			selectPlanUrl: {
				type: String,
				required: true
			},
			paymentMethod: {
				type: String,
				required: true
			},
			cardOnFile: {
				type: Boolean,
				required: true
			},
			showPrepaymentPaymentMethods: {
				type: Boolean,
				required: true
			},
			stripeKey: {
				type: String,
				required: true
			},
			poNumber: {
				type: String,
				default: null
			},
			newPlan: {
				type: Object as PropType<Plan>,
				required: true
			},
			existingCardInfo: {
				type: Object,
				required: true
			},
			collectTaxId: {
				type: Boolean,
				required: true
			},
			showHeaderAndInvoiceOption: {
				type: Boolean,
				default: true
			}
		},
		emits: [
			'card-changed',
			'update:payment-method',
			'update:po-number'
		],
		setup(props, { emit }) {
			const internalPaymentMethod = ref(props.paymentMethod);

			watch(() => props.paymentMethod, (newValue) => {
				internalPaymentMethod.value = newValue;
			});

			return {
				emit,
				internalPaymentMethod,
				showInvoiceModal: ref(false)
			};
		}
	});
</script>